import Vue from 'vue';

let VueTruncate = require('vue-truncate-filter');

Vue.use(VueTruncate);
